import { PropsWithChildren } from 'react';

type ButtonProps = PropsWithChildren<{
    className?: string;
}>;

export function Button({ children, className = '' }: ButtonProps) {
    return (
        <div
            className={`flex items-center gap-2 rounded-[20px] border-1 border-gray-900 bg-black/50 px-4 py-1 text-white backdrop-opacity-75 ${className}`}
        >
            {children}
        </div>
    );
}
